import BaseMapper from '../../BaseMapper';

const EventWithSeasonMapper = (data, context) => {
    BaseMapper.renameField(data, 'seasons', 'events');

    return data;
};

export default EventWithSeasonMapper;
